import styled, { css } from 'styled-components'

const StyledButton = styled.button`
background: white;
box-shadow: 1px 1px 2px lightgray;
color: black;
padding: 5px 15px;
border-radius: 15px;
border: transparent;
${props => props.submit && css`
width: 65%;
border-radius: 5px;
`}

:hover {
  box-shadow: 2px 2px 4px gray;
}

:active {
  box-shadow: none;
}

:focus {
  outline: none;
}

${props =>
    props.primary && css`
    background: var(--brand-red);
    color: white;
  `};
${props => props.info && css`
  color: blue;
`}
${props => props.confirm && css`
  color: green;
`}
${props => props.delete && css`
color: red;
`}
`

export const Button = props => {
  return <StyledButton {...props}>{props.children}</StyledButton>
}